import { render, staticRenderFns } from "./TermCreate.vue?vue&type=template&id=2959dc16"
import script from "../../../controllers/custom/term/term-create.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/term/term-create.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports